// Plugins
const transitionPlugin = require('./plugins/transitions')
const typeScalePlugin = require('./plugins/typeScale')

// Themes
const colors = require('./theme/colors')
const durations = require('./theme/durations')
const timingFunctions = require('./theme/timingFunctions')

const { black, white, transparent, blue, gray, green, purple, red } = colors

module.exports = {
  theme: {
    extend: {
      boxShadow: {
        outline: `0 0 0 2px ${blue['60']}`
      },
      zIndex: {
        100: 100,
        90: 90,
        80: 80,
        70: 70,
        60: 60
      }
    },
    durations,
    timingFunctions,
    colors: {
      primary: {
        default: blue['60'],
        hover: blue['70'],
        active: blue['80']
      },
      black,
      white,
      transparent,
      blue,
      gray,
      green,
      purple,
      red
    }
  },
  variants: {
    backgroundColor: ['hover', 'focus', 'active'],
    textColor: ['hover', 'focus', 'active']
  },
  plugins: [transitionPlugin({ durations, timingFunctions }), typeScalePlugin]
}
